import * as React from 'react';
import { dispatchInputChange } from './dispatchNativeEvent';
var Types;

(function (Types) {
  Types["TEXT"] = "text";
  Types["PASSWORD"] = "password";
})(Types || (Types = {}));

var useInputOpened = _ref => {
  var {
    value,
    type = Types.TEXT,
    loading,
    cleanable,
    onChange
  } = _ref;
  var [text, setText] = React.useState(value || '');
  var [showEraseButton, setShowEraseButton] = React.useState(false);
  var [currentType, setCurrentType] = React.useState(type);
  var inputRef = React.useRef();

  var handleEraseButton = () => {
    var _inputRef$current, _inputRef$current$foc;

    var EMPTY = '';
    setText(EMPTY);
    dispatchInputChange(inputRef.current, EMPTY);
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$foc = _inputRef$current.focus) === null || _inputRef$current$foc === void 0 ? void 0 : _inputRef$current$foc.call(_inputRef$current);
  };

  var handleEyeButton = () => {
    setCurrentType(currentType === Types.PASSWORD ? Types.TEXT : Types.PASSWORD);
  };

  var handleOnChange = e => {
    e.preventDefault();
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
    setText(e.currentTarget.value);
  };

  var updateShowEraseButton = React.useCallback(field => setShowEraseButton(Boolean(!loading && type !== Types.PASSWORD && cleanable && field.length > 0)), [cleanable, loading, type]);

  var showEyeButton = () => type === Types.PASSWORD && !loading;

  React.useEffect(() => {
    updateShowEraseButton(value || text);
  }, [value, text, updateShowEraseButton]);
  React.useEffect(() => {
    setText(value || '');
  }, [value]);
  return {
    showEyeButton,
    handleOnChange,
    handleEyeButton,
    handleEraseButton,
    showEraseButton,
    text,
    currentType,
    inputRef
  };
};

export { useInputOpened, Types };
//# sourceMappingURL=useInputOpened.js.map